import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { publicRoutes, protectedRoutes, legacyRedirects } from './routes';
import RouteGuard, { PublicRouteGuard } from './RouteGuard';
import DashboardLayout from '../../shared/components/layout/DashboardLayout';
import Forbidden from '../../features/auth/pages/Forbidden';

/**
 * AppRouter Component
 * Main router component that handles all application routing
 */
const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        {publicRoutes.map((route, index) =>
          route.redirect ? (
            <Route
              key={`public-${index}`}
              path={route.path}
              element={<Navigate to={route.redirect} replace />}
            />
          ) : (
            <Route
              key={`public-${index}`}
              path={route.path}
              element={route.element}
            />
          )
        )}

        {/* Protected Admin Routes */}
        <Route
          path="/admin/*"
          element={
            <RouteGuard>
              <DashboardLayout />
            </RouteGuard>
          }
        >
          {protectedRoutes.map((route, index) => (
            <Route
              key={`protected-${index}`}
              path={route.path}
              element={
                route.module ? (
                  <RouteGuard module={route.module}>{route.element}</RouteGuard>
                ) : route.element
              }
            />
          ))}
          <Route path="403" element={<Forbidden />} />
          {/* Default admin redirect */}
          <Route index element={<Navigate to="dashboard" replace />} />
        </Route>

        {/* Legacy Redirects */}
        {legacyRedirects.map((redirect, index) => (
          <Route
            key={`legacy-${index}`}
            path={redirect.from}
            element={<Navigate to={redirect.to} replace />}
          />
        ))}

        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;

// Export route utilities
export {
  publicRoutes,
  protectedRoutes,
  legacyRedirects,
  RouteGuard,
  PublicRouteGuard,
};
export * from './routes';
